import React from 'react';
import NumberFormatter from './NumberFormatter';
import AsyncCoinImage from './../../images/async_coin.png';

export default class Coin extends React.Component {
  render () {
    return (<span className="c-coin" data-tip={this.props.coin + ' ASC'}>
      <NumberFormatter number={this.props.coin} disableTooltip={true}/>
      <img className="c-coin__icon" src={AsyncCoinImage} role="presentation"/>
    </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Components/Coin.js